import { render, staticRenderFns } from "./printMChat_bak.vue?vue&type=template&id=873f3d40&scoped=true"
import script from "./printMChat_bak.vue?vue&type=script&lang=js"
export * from "./printMChat_bak.vue?vue&type=script&lang=js"
import style0 from "./printMChat_bak.vue?vue&type=style&index=0&id=873f3d40&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873f3d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('873f3d40')) {
      api.createRecord('873f3d40', component.options)
    } else {
      api.reload('873f3d40', component.options)
    }
    module.hot.accept("./printMChat_bak.vue?vue&type=template&id=873f3d40&scoped=true", function () {
      api.rerender('873f3d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/mChat/printMChat/printMChat_bak.vue"
export default component.exports